/**
 * stop-algorithm-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { validateAs, validateFor } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * A server sends an {@link StopAlgorithmResponse} whenever a running
 * algorithm stops executing. This is generally due to a {@link
 * StopAlgorithmResponse} sent by the client, but the server could choose to
 * stop an algorithm independently (though at the time of this writing there
 * are no such triggers).
 */
@validateFor(MessageTag.RSP_STOP_ALGORITHM)
export class StopAlgorithmResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_STOP_ALGORITHM;

  @validateAs("string")
  public name : string;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/stop-algorithm-response.ts